import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorCorrectionHeaderSearch = () => {
  const correctionHeaderSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-correction-header/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        } else {
          callback(null)
        }
      }
      loading(false)
    })
  }, [])

  return { correctionHeaderSearch }
}

export default InteractorCorrectionHeaderSearch
